module.exports = __webpack_public_path__ + "static/media/20.fba82b9e.jpg";